import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
  .csc-password-check {
    display: none;
  }

  .csc-password-check.has-errors {
    display: block;
  }
`
